import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowLeft from '@/images/arrows/ArrowLeft.svg';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { useAgentInsightsContext } from '../../contex/useAgentInsightsContext';

const StyledBackButton = styled(IconButton)`
    gap: 10px;
    padding: 4px 12px 4px 0;

    &:active {
        background-color: ${({ theme }) => theme.colors.black[50]};
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
    }

    color: ${({ theme }) => theme.colors.secondary.main};
    font-weight: 600;
    font-size: 18px;
    margin: 0 32px 0 0;
`;

const StyledMaskedIcon = styled(MaskedIcon)`
    color: ${({ theme }) => theme.colors.black[700]};
`;

interface Props {
    text: string;
}

export const BackButton = ({ text }: Props) => {
    const { setConversationTopicFilter, setConversationIntentFilter } = useAgentInsightsContext();

    return (
        <StyledBackButton
            onClick={() => {
                setConversationTopicFilter(undefined);
                setConversationIntentFilter(undefined);
            }}>
            <StyledMaskedIcon src={ArrowLeft} size="32px" />
            {text}
        </StyledBackButton>
    );
};
